import { makeAutoObservable } from 'mobx';

import { ISelectInfo, SelectInfo } from '../constants';
import { RemarkInfoItem, RemarkOptionItem } from '../dto';
import { VenueRemarkModel } from '../model';

class VenueRemarkStore {
  venueRemark: VenueRemarkModel = new VenueRemarkModel();
  venueRemarkFieldInfo: RemarkInfoItem[] = [];

  selectedIndex: ISelectInfo = SelectInfo.BUILDING_ETC;
  editMode = false;
  isCancelDialogOpen = false;
  isConfirmDialogOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  setEditMode(flag: boolean) {
    this.editMode = flag;
  }

  setSelectedIndex(selectedInfo: ISelectInfo) {
    this.selectedIndex = selectedInfo;
  }

  setCancelDialogStatus(flag: boolean) {
    this.isCancelDialogOpen = flag;
  }

  setConfirmDialogStatus(flag: boolean) {
    this.isConfirmDialogOpen = flag;
  }

  isCode(key: string) {
    const res = key.match(/[A-Z]+_O_[0-9]{3}/);
    if (res) return res[0] === res.input;
    return false;
  }

  convertKeyToCode(key: string) {
    return key.replace(/(.{3})$/g, '_$1').toUpperCase();
  }

  convertCodeToKey(code: string) {
    return code.replace(/_/g, '').toLowerCase();
  }

  getData(key: string) {
    const value = this.venueRemark[key];
    if (!!value && this.isCode(value)) {
      return this.getNestedValue(key, value);
    }
    return value;
  }

  getNestedValue(key: string, code: string) {
    const targetKey = this.convertKeyToCode(key);
    return this.venueRemarkFieldInfo
      .find((ele: RemarkInfoItem) => ele.code === targetKey)
      ?.options.find((option: RemarkOptionItem) => option.code === code);
  }
}

const venueRemarkStoreImpl = new VenueRemarkStore();
export default venueRemarkStoreImpl;
